import SearchBar from '@/components/company/filters/SearchBar';
import FilterSelect from '@/components/company/filters/FilterSelect';
import ClearFilterButton from '@/components/company/filters/ClearFilterButton';

interface Option {
  label: string;
  value: string;
}

interface PunishmentFiltersProps {
  searchTerm: string;
  setSearchTerm: (val: string) => void;
  selectedRole: string;
  setSelectedRole: (val: string) => void;
  selectedStatus: string;
  setSelectedStatus: (val: string) => void;
  clearFilters: () => void;
  roleOptions: Option[];
}

export const PunishmentFilters = ({
  searchTerm,
  setSearchTerm,
  selectedRole,
  setSelectedRole,
  selectedStatus,
  setSelectedStatus,
  clearFilters,
  roleOptions,
}: PunishmentFiltersProps) => (
  <div className="flex justify-start mt-5 px-5 gap-2">
    <SearchBar
      value={searchTerm}
      onChange={setSearchTerm}
      placeholder="Search punishments..."
      className="w-72"
    />
    <FilterSelect
      label="Role"
      options={roleOptions}
      value={selectedRole}
      onChange={setSelectedRole}
    />
    <FilterSelect
      label="Status"
      options={[
        { label: 'Published', value: 'Published' },
        { label: 'Unpublished', value: 'Unpublished' },
      ]}
      value={selectedStatus}
      onChange={setSelectedStatus}
    />
    <ClearFilterButton onClear={clearFilters} />
  </div>
);
